// extracted by mini-css-extract-plugin
module.exports = {"close":"Popup_close__OGgSL"};